export const routesConstants = {
    ROUTES_FETCHING: 'ROUTES_FETCHING',
    ROUTES_FETCHED: 'ROUTES_FETCHED',
    ROUTES_SUBMITTING: 'ROUTES_SUBMITTING',
    ROUTES_SUBMITTED: 'ROUTES_SUBMITTED',
    LIST_OF_ROUTES: 'LIST_OF_ROUTES',
    GET_ROUTE_BY_CODE: 'GET_ROUTE_BY_CODE',
    DESTINATION_BRANCHES: 'DESTINATION_BRANCHES',
    ORIGIN_BRANCHES: 'ORIGIN_BRANCHES'
}